import React from 'react';
import './MoiTruong.css'

function MoiTruong () {
   
        return (
   <div className="moi-truong-page">
    {/* Breadcrumb */}
    <div className="moi-truong-breadcrumb">
        <span>Trang chủ</span>
        <span className="moi-truong-dot">›</span>
        <span>Môi trường</span>
    </div>

    {/* Title */}
    <h2 className="moi-truong-title">
        Môi trường
    </h2>

    {/* Overview */}
    <div className="moi-truong-overview-grid">

        <div className="moi-truong-overview-card">
            <div className="moi-truong-overview-top">
                <div className="moi-truong-overview-icon purple">
                    🎁
                </div>

                <div>
                    <h4>Cơ sở sản xuất</h4>
                    <h2>142</h2>
                    <p>Tổng số cơ sở trong KCN</p>
                </div>
            </div>

            <a href="/">Xem chi tiết →</a>
        </div>

        <div className="moi-truong-overview-card">
            <div className="moi-truong-overview-top">
                <div className="moi-truong-overview-icon green">
                    🍃
                </div>

                <div>
                    <h4>Giám sát môi trường</h4>
                    <h2>05</h2>
                    <p>Trạm quan trắc tự động</p>
                </div>
            </div>

            <a href="/">Xem chi tiết →</a>
        </div>

        <div className="moi-truong-overview-card">
            <div className="moi-truong-overview-top">
                <div className="moi-truong-overview-icon yellow">
                    ⚠
                </div>

                <div>
                    <h4>Cảnh báo môi trường</h4>
                    <h2>02</h2>
                    <p>Cảnh báo đang hoạt động</p>
                </div>
            </div>

            <a href="/">Xem chi tiết →</a>
        </div>

        <div className="moi-truong-overview-card">
            <div className="moi-truong-overview-top">
                <div className="moi-truong-overview-icon pink">
                    📋
                </div>

                <div>
                    <h4>Báo cáo, kiểm tra</h4>
                    <h2>18</h2>
                    <p>Báo cáo trong tháng 5</p>
                </div>
            </div>

            <a href="/">Xem chi tiết →</a>
        </div>
    </div>

    {/* Chart + Water */}
    <div className="moi-truong-chart-water-grid">

        {/* Air Quality */}
        <div className="moi-truong-card">
            <div className="moi-truong-card-header">
                <h3>Chất lượng môi trường không khí</h3>

                <div className="moi-truong-filter-group">
                    <select className="moi-truong-select">
                        <option>
                            Trạm: Trạm quan trắc KCN Biên Hòa
                        </option>
                    </select>

                    <select className="moi-truong-select small">
                        <option>7 ngày qua</option>
                    </select>
                </div>
            </div>

            <div className="moi-truong-chart-layout">

                {/* Chart */}
                <div className="moi-truong-chart-wrapper">

                    {/* Y axis */}
                    <div className="moi-truong-y-axis">
                        <span>μg/m³</span>
                        <span>250</span>
                        <span>200</span>
                        <span>150</span>
                        <span>100</span>
                        <span>50</span>
                        <span>0</span>
                    </div>

                    {/* Chart */}
                    <div className="moi-truong-chart">

                        {/* Grid line */}
                        <div className="moi-truong-grid-line line-1"></div>
                        <div className="moi-truong-grid-line line-2"></div>
                        <div className="moi-truong-grid-line line-3"></div>
                        <div className="moi-truong-grid-line line-4"></div>
                        <div className="moi-truong-grid-line line-5"></div>
                        <div className="moi-truong-grid-line line-6"></div>

                        {/* PM2.5 */}
                        <svg
                            className="moi-truong-line-svg"
                            viewBox="0 0 600 260"
                            preserveAspectRatio="none"
                        >
                            <polyline
                                className="moi-truong-line-purple"
                                points="20,210 100,190 180,185 260,195 340,188 420,198 500,193 580,187"
                            />

                            <circle cx="20" cy="210" r="4" className="moi-truong-dot-purple" />
                            <circle cx="100" cy="190" r="4" className="moi-truong-dot-purple" />
                            <circle cx="180" cy="185" r="4" className="moi-truong-dot-purple" />
                            <circle cx="260" cy="195" r="4" className="moi-truong-dot-purple" />
                            <circle cx="340" cy="188" r="4" className="moi-truong-dot-purple" />
                            <circle cx="420" cy="198" r="4" className="moi-truong-dot-purple" />
                            <circle cx="500" cy="193" r="4" className="moi-truong-dot-purple" />
                            <circle cx="580" cy="187" r="4" className="moi-truong-dot-purple" />

                            {/* PM10 */}
                            <polyline
                                className="moi-truong-line-pink"
                                points="20,185 100,165 180,170 260,160 340,175 420,170 500,168 580,162"
                            />

                            <circle cx="20" cy="185" r="4" className="moi-truong-dot-pink" />
                            <circle cx="100" cy="165" r="4" className="moi-truong-dot-pink" />
                            <circle cx="180" cy="170" r="4" className="moi-truong-dot-pink" />
                            <circle cx="260" cy="160" r="4" className="moi-truong-dot-pink" />
                            <circle cx="340" cy="175" r="4" className="moi-truong-dot-pink" />
                            <circle cx="420" cy="170" r="4" className="moi-truong-dot-pink" />
                            <circle cx="500" cy="168" r="4" className="moi-truong-dot-pink" />
                            <circle cx="580" cy="162" r="4" className="moi-truong-dot-pink" />

                            {/* SO2 */}
                            <polyline
                                className="moi-truong-line-yellow"
                                points="20,145 100,120 180,125 260,115 340,140 420,132 500,120 580,130"
                            />

                            <circle cx="20" cy="145" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="100" cy="120" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="180" cy="125" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="260" cy="115" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="340" cy="140" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="420" cy="132" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="500" cy="120" r="4" className="moi-truong-dot-yellow" />
                            <circle cx="580" cy="130" r="4" className="moi-truong-dot-yellow" />

                            {/* NO2 */}
                            {/* <polyline
                                className="moi-truong-line-red"
                                points="20,225 100,220 180,222 260,218 340,225 420,221 500,220 580,217"
                            /> */}

                            {/* <circle cx="20" cy="225" r="4" className="moi-truong-dot-red" />
                            <circle cx="100" cy="220" r="4" className="moi-truong-dot-red" />
                            <circle cx="180" cy="222" r="4" className="moi-truong-dot-red" />
                            <circle cx="260" cy="218" r="4" className="moi-truong-dot-red" />
                            <circle cx="340" cy="225" r="4" className="moi-truong-dot-red" />
                            <circle cx="420" cy="221" r="4" className="moi-truong-dot-red" />
                            <circle cx="500" cy="220" r="4" className="moi-truong-dot-red" />
                            <circle cx="580" cy="217" r="4" className="moi-truong-dot-red" /> */}

                            {/* CO */}
                            <polyline
                                className="moi-truong-line-green"
                                points="20,100 100,55 180,72 260,50 340,95 420,78 500,58 580,82"
                            />

                            <circle cx="20" cy="100" r="4" className="moi-truong-dot-green" />
                            <circle cx="100" cy="55" r="4" className="moi-truong-dot-green" />
                            <circle cx="180" cy="72" r="4" className="moi-truong-dot-green" />
                            <circle cx="260" cy="50" r="4" className="moi-truong-dot-green" />
                            <circle cx="340" cy="95" r="4" className="moi-truong-dot-green" />
                            <circle cx="420" cy="78" r="4" className="moi-truong-dot-green" />
                            <circle cx="500" cy="58" r="4" className="moi-truong-dot-green" />
                            <circle cx="580" cy="82" r="4" className="moi-truong-dot-green" />
                        </svg>

                        {/* X axis */}
                        <div className="moi-truong-x-axis">
                            <span>06/05</span>
                            <span>07/05</span>
                            <span>08/05</span>
                            <span>09/05</span>
                            <span>10/05</span>
                            <span>11/05</span>
                            <span>12/05</span>
                        </div>
                    </div>
                </div>

                {/* Current data */}
                <div className="moi-truong-current-table">
                    <div className="moi-truong-current-title">
                        Chỉ số hiện tại (12/05/2026 10:00)
                    </div>

                    <table>
                        <tbody>
                            <tr>
                                <td>PM2.5</td>
                                <td>35 μg/m³</td>
                                <td className="good">Tốt</td>
                            </tr>

                            <tr>
                                <td>PM10</td>
                                <td>68 μg/m³</td>
                                <td className="medium">Trung bình</td>
                            </tr>

                            <tr>
                                <td>SO2</td>
                                <td>15 μg/m³</td>
                                <td className="good">Tốt</td>
                            </tr>

                            <tr>
                                <td>NO2</td>
                                <td>28 μg/m³</td>
                                <td className="good">Tốt</td>
                            </tr>

                            <tr>
                                <td>CO</td>
                                <td>0.6 mg/m³</td>
                                <td className="good">Tốt</td>
                            </tr>
                        </tbody>
                    </table>

                    <a href="/">Xem chi tiết →</a>
                </div>
            </div>

            {/* Legend */}
            <div className="moi-truong-legend">
                <span className="purple">● PM2.5 (μg/m³)</span>
                <span className="pink">● PM10 (μg/m³)</span>
                <span className="yellow">● SO2 (μg/m³)</span>
                <span className="red">● NO2 (μg/m³)</span>
                <span className="green">● CO (mg/m³)</span>
            </div>
        </div>

        {/* Water table */}
        <div className="moi-truong-card">
            <div className="moi-truong-card-header">
                <h3>
                    Chất lượng nước thải (Nước thải sau xử lý)
                </h3>

                <div className="moi-truong-filter-group">
                    <select className="moi-truong-select">
                        <option>
                            Trạm: Trạm XLNT tập trung KCN Biên Hòa
                        </option>
                    </select>

                    <select className="moi-truong-select small">
                        <option>7 ngày qua</option>
                    </select>
                </div>
            </div>

            <div className="moi-truong-water-scroll">
                <table className="moi-truong-water-table">
                    <thead>
                        <tr>
                            <th>Thông số</th>
                            <th>Đơn vị</th>
                            <th>Kết quả mới nhất</th>
                            <th>QCVN 40:2011/BTNMT (Cột A)</th>
                            <th>Đánh giá</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>pH</td>
                            <td>-</td>
                            <td>6.8</td>
                            <td>6 - 9</td>
                            <td className="good">Đạt</td>
                        </tr>

                        <tr>
                            <td>BOD5</td>
                            <td>mg/L</td>
                            <td>18</td>
                            <td>30</td>
                            <td className="good">Đạt</td>
                        </tr>

                        <tr>
                            <td>COD</td>
                            <td>mg/L</td>
                            <td>42</td>
                            <td>75</td>
                            <td className="good">Đạt</td>
                        </tr>

                        <tr>
                            <td>TSS</td>
                            <td>mg/L</td>
                            <td>25</td>
                            <td>50</td>
                            <td className="good">Đạt</td>
                        </tr>

                        <tr>
                            <td>Amoni (NH4+ tính theo N)</td>
                            <td>mg/L</td>
                            <td>4.2</td>
                            <td>10</td>
                            <td className="good">Đạt</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <a href="/" className="moi-truong-link">
                Xem chi tiết →
            </a>
        </div>
    </div>

    {/* Bottom */}
    <div className="moi-truong-bottom-grid">

        {/* Factory list */}
        <div className="moi-truong-card">
            <div className="moi-truong-table-header">
                <h3>Danh sách cơ sở sản xuất</h3>

                <div className="moi-truong-tabs">
                    <button className="active">Tất cả (142)</button>
                    <button>Đang hoạt động (130)</button>
                    <button>Tạm dừng (8)</button>
                </div>
            </div>

            <div className="moi-truong-search-row">
                <input
                    type="text"
                    placeholder="Tìm kiếm cơ sở..."
                    className="moi-truong-search"
                />

                <button className="moi-truong-export">
                    Xuất Excel
                    <i class="fa-solid fa-angle-down icon-moi-truong-down"></i>
                    {/* <i className="fa-solid fa-arrow-down icon-moi-truong-down"></i> */}
                </button>
            </div>

            <div className="moi-truong-table-scroll">
                <table className="moi-truong-factory-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Tên cơ sở</th>
                            <th>Ngành nghề</th>
                            <th>Trạng thái</th>
                            <th>Giấy phép môi trường</th>
                            <th>Ngày hết hạn</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Công ty TNHH An Phát</td>
                            <td>Sản xuất bao bì</td>
                            <td>
                                <span className="status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>GPMT-AG-2024-0012</td>
                            <td>16/08/2022</td>
                        </tr>

                        <tr>
                            <td>2</td>
                            <td>Công ty CP Cơ khí AG</td>
                            <td>Cơ khí chế tạo</td>
                            <td>
                                <span className="status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>GPMT-AG-2024-0031</td>
                            <td>22/09/2022</td>
                        </tr>

                        <tr>
                            <td>3</td>
                            <td>Công ty TNHH May Mặc ABC</td>
                            <td>May mặc</td>
                            <td>
                                <span className="status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>GPMT-AG-2024-0025</td>
                            <td>10/09/2022</td>
                        </tr>

                        <tr>
                            <td>4</td>
                            <td>Công ty TNHH Nhựa An Giang</td>
                            <td>Sản xuất nhựa</td>
                            <td>
                                <span className="status-active">
                                    Đang hoạt động
                                </span>
                            </td>
                            <td>GPMT-AG-2024-0018</td>
                            <td>05/11/2022</td>
                        </tr>

                        <tr>
                            <td>5</td>
                            <td>Công ty CP Thực phẩm AG</td>
                            <td>Chế biến thực phẩm</td>
                            <td>
                                <span className="status-pause">
                                    Tạm dừng
                                </span>
                            </td>
                            <td>GPMT-AG-2024-0020</td>
                            <td>12/08/2022</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="moi-truong-pagination">
                <a href="/">Xem tất cả cơ sở →</a>

                <div className="moi-truong-page-number">
                    <i className="fa-solid fa-chevron-left icon-moi-truong-next-left"></i>
                    <button className="active">1</button>
                    <button>2</button>
                    <button>3</button>
                    <span>...</span>
                    <button>15</button>
                    <i className="fa-solid fa-chevron-right icon-moi-truong-next-right"></i>
                </div>
            </div>
        </div>

        {/* Warning */}
        <div className="moi-truong-card">
            <div className="moi-truong-warning-header">
                <h3>Cảnh báo môi trường</h3>

                <a href="/">Xem tất cả →</a>
            </div>

            <div className="moi-truong-warning-list">

                <div className="moi-truong-warning-item">
                    <div className="moi-truong-warning-left">
                        <div className="warning red">
                            <i className="fa-solid fa-triangle-exclamation"></i>
                        </div>

                        <div>
                            <h4>Vượt ngưỡng bụi PM10</h4>
                            <p>Trạm quan trắc KCN Bình Hòa</p>
                        </div>
                    </div>

                    <div className="moi-truong-warning-right">
                        <span>12/05/2026 09:15</span>
                        <label className="danger">
                            Đang diễn ra
                        </label>
                    </div>
                </div>

                <div className="moi-truong-warning-item">
                    <div className="moi-truong-warning-left">
                        <div className="warning orange">

                            <i className="fa-solid fa-triangle-exclamation"></i>
                        </div>

                        <div>
                            <h4>Vượt ngưỡng COD trong nước thải</h4>
                            <p>Trạm XLNT tập trung KCN Bình Hòa</p>
                        </div>
                    </div>

                    <div className="moi-truong-warning-right">
                        <span>11/05/2026 16:40</span>
                        <label className="danger">
                            Đang diễn ra
                        </label>
                    </div>
                </div>

                <div className="moi-truong-warning-item">
                    <div className="moi-truong-warning-left">
                        <div className="warning yellow">
                            <i className="fa-solid fa-triangle-exclamation"></i>
                        </div>

                        <div>
                            <h4>Lưu lượng nước thải tăng cao bất thường</h4>
                            <p>Trạm XLNT tập trung KCN Bình Hòa</p>
                        </div>
                    </div>

                    <div className="moi-truong-warning-right">
                        <span>10/05/2026 10:20</span>
                        <label className="success">
                            Đã xử lý
                        </label>
                    </div>
                </div>

                <div className="moi-truong-warning-item">
                    <div className="moi-truong-warning-left">
                        <div className="warning purple">
                            <i className="fa-solid fa-circle-exclamation"></i>
                        </div>

                        <div>
                            <h4>Bụi PM2.5 tăng nhẹ</h4>
                            <p>Trạm quan trắc KCN Bình Hòa</p>
                        </div>
                    </div>

                    <div className="moi-truong-warning-right">
                        <span>10/05/2026 08:30</span>
                        <label className="success">
                            Đã xử lý
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* Utilities */}
    <div className="moi-truong-utility-section">
        <h3>Tiện ích môi trường</h3>

        <div className="moi-truong-utility-grid">

            <div className="moi-truong-utility-card">
                <div className="moi-truong-utility-icon">📊</div>
                <div>
                    <h4>Quan trắc tự động</h4>
                <p>Xem dữ liệu quan trắc theo thời gian thực</p>
                </div>
            </div>

            <div className="moi-truong-utility-card">
                <div className="moi-truong-utility-icon">📄</div>
               <div>
                 <h4>Báo cáo định kỳ</h4>
                <p>Tổng hợp báo cáo môi trường</p>
               </div>
            </div>

            <div className="moi-truong-utility-card">
                <div className="moi-truong-utility-icon">🔎</div>
             <div>
                   <h4>Kiểm tra môi trường</h4>
                <p>Lịch kiểm tra, xử lý vi phạm</p>
             </div>
            </div>

            <div className="moi-truong-utility-card">
                <div className="moi-truong-utility-icon">📑</div>
               <div>
                 <h4>Văn bản, quy định</h4>
                <p>Tra cứu văn bản, quy chuẩn</p>
               </div>
            </div>

            <div className="moi-truong-utility-card">
                <div className="moi-truong-utility-icon">📑</div>
               <div>
                 <h4>Biểu mẫu</h4>
                <p>Tải biểu mẫu môi trường</p>
               </div>
            </div>
        </div>
    </div>
</div>

        );
    }


export default MoiTruong;